import React from 'react'
import "./MenuItems.css"

function MenuItems({item}) {
    return (
        <div className="menuitems">
            <div className="menuitems__nameprice">
                <span className="menuitems__name">{item.name}</span>
                <span className="menuitems__price">${item.price}</span>
            </div>
            <span className="menuitems__desc">{item.description}</span>
            
        </div>
    )
}

export default MenuItems
